import React from 'react';
import { Alert } from '@mui/material';
import { ApprovalView } from '../../../../../../services/RefundService/types/refundTypes';
import { getWarningMessage } from '../constants';

interface WarningSectionProps {
  approval: ApprovalView;
}

export const WarningSection: React.FC<WarningSectionProps> = ({ approval }) => (
  <Alert severity="warning">{getWarningMessage(approval)}</Alert>
);

export default WarningSection;
